<template>  
  <div class="alertBox mcontent">
    <div class="row">
      <div class="col-12">
        <q-checkbox v-model="hasAudio" :label="$t('global.AudioAlertOn')"/>
      </div>
    </div>
    <div class="row">  
      <div class="col ">{{$t('global.Alert')}}</div>
      <div class="col ">{{$t('global.Unit')}}</div>
      <div class="col ">{{$t('global.DateTime')}}</div>
      <div class="col-1">
         {{$t('global.Map')}}
      </div>
    </div>
    <hr>
    <div v-for="alert in tableData" :key="alert.AlertID">    
      <div class="row">  
        <div class="col">
          <p class="link" @click="editAlert(alert)" >{{alert.AlertConfigName}}</p>
        </div>
         <div class="col ">{{alert.DeviceName}}</div>
         <div class="col ">{{dateFormat(alert.AlertDateTime)}}</div>
        <div  class="col-1 "><input type="checkbox" :ref="alert.AlertID" :value="alert.AlertID" :id="alert.AlertID" :name="alert.AlertID" @change="showAlert(alert)"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {eventBus} from '../main'
import axios from 'axios'
import qs from 'qs'
import { date } from 'quasar'

export default {
  name: 'Alerts',
  data () {
    return {
      form: {
        SessionId: null,
      },
      cbAlert: [],
      tableData: [],
      hasAudio: true
    }
  },
  methods: {
    loadData(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "GetOpenAlert"
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              this.tableData = response.data
              if(this.hasAudio){
                this.$emit('alert-count', response.data.length)
              }
              response.data.forEach(alert => {
                if(this.cbAlert[alert.AlertID] == undefined){        
                    //this.cbAlert[alert.AlertID] = false
                }   
              })       
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },
    showAlert(a){
      if (this.$refs[a.AlertID][0].checked == true){
        eventBus.$emit('showAlert', a)
      }
      else{
        eventBus.$emit('removeAlert', a)
      }
    },
    editAlert(a){
      eventBus.$emit('AlertEdit', a)
    },
    dateFormat(val) {
      if (this.$i18n.locale == "de")
        return date.formatDate(val, 'DD.MM.YYYY HH:mm:ss')
      else
        return date.formatDate(val, 'MM/DD/YYYY HH:mm:ss')
    },
  },
  watch: {
   
    
  },
  created () {
    this.loadData() 
     eventBus.$on('dataLoad', (data) => {
      this.loadData()
    })

  },
}
function round(value, decimals) {
  return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
}
</script>

<style scoped>
  .alertBox{
    color:#0c0c0c;  
    font-size: 12px;
    padding: 3px;
  }
  .link {
  color: #027be3;
}
.link:hover {
  color: green;
}
.mcontent{
  padding: 10px;
  padding-top: 0px;
}
</style>
